import React from 'react';
import { Link } from 'react-router-dom';
import StoreDownloadLink from './StoreDownloadLink';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';
import { ReactComponent as NavLogo } from './assets/nav-logo.svg';
import { ReactComponent as NavCtaArrow } from './assets/nav-cta-arrow.svg';
import HomeRedesignNavRating from './HomeRedesignNavRating';

const HomeRedesignNav: React.FC = () => {
  const s = useHomeRedesignStrings();

  return (
    <header className="sticky top-0 z-50 overflow-visible border-b border-[rgba(74,33,71,0.1)] bg-[rgba(252,247,250,0.85)] backdrop-blur-[5px]">
      <nav className="mx-auto grid w-full max-w-[1440px] grid-cols-[1fr_auto_1fr] items-center gap-2 overflow-visible px-5 pb-[13px] pt-[max(0.75rem,env(safe-area-inset-top))] sm:px-8 hero:gap-4 hero:px-[80px] hero:pb-[23px] hero:pt-[max(1.375rem,env(safe-area-inset-top))]">
        <Link
          to="/"
          className="relative shrink-0 justify-self-start text-[#EB42B2] hero:w-[120px]"
          aria-label={s.nav.logoAria}
        >
          <NavLogo
            aria-hidden
            className="block h-7 w-[89px] max-w-none hero:h-[37px] hero:w-[120px]"
          />
        </Link>

        <HomeRedesignNavRating />

        <div className="flex shrink-0 items-center justify-end justify-self-end gap-2 hero:h-[39px] hero:gap-3">
          <Link
            to="/ciudades"
            className="hidden rounded-lg px-4 py-2.5 font-jakarta text-sm font-semibold leading-normal text-chisme-primary transition-colors hover:text-chisme-primary/85 hero:inline-flex hero:px-4 hero:py-2.5 hero:text-[14px]"
          >
            {s.nav.explorePlans}
          </Link>
          <StoreDownloadLink className="inline-flex min-h-[44px] items-center justify-center rounded-full border border-[#2a0f2a] px-4 font-jakarta text-sm font-semibold tracking-[0.01em] text-[#2a0f2a] hero:hidden">
            {s.nav.openApp}
          </StoreDownloadLink>
          <StoreDownloadLink className="hidden h-[39px] w-[131px] shrink-0 items-center justify-center gap-[6px] rounded-full bg-chisme-primary px-[18px] py-[11px] font-jakarta text-[13.5px] font-bold leading-normal tracking-[-0.067px] text-white hero:inline-flex">
            {s.nav.openApp}
            <NavCtaArrow aria-hidden className="size-[13px] max-w-none shrink-0" />
          </StoreDownloadLink>
        </div>
      </nav>
    </header>
  );
};

export default HomeRedesignNav;
